import { Component, OnInit, Input, TemplateRef, HostBinding, ChangeDetectionStrategy, AfterContentInit } from '@angular/core';
import { NgxExcelColumnType } from '../../models/models';
import { NgxExcelCellInterface } from '../../interfaces/ngx-excel-cell.interface';
import { NgxExcelContextComponent } from '../ngx-excel-context/ngx-excel-context.component';

@Component({
  selector: 'ngx-excel-cell[headCell]',
  template: `
    <div class="cell" [class.cell-tooltip]="tooltip">
      {{ column.label }}
      <i *ngIf="tooltip" class="tooltip" nz-icon nzType="question-circle" nzTheme="outline" nz-tooltip [nzTitle]="tooltip"></i>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class NgxExcelHeadCellComponent extends NgxExcelCellInterface implements OnInit, AfterContentInit {

  columnTypeEnums = NgxExcelColumnType;

  @Input() label: string;
  @Input() tooltip: TemplateRef<void> | string;
  @Input() excelContext: NgxExcelContextComponent;
  @HostBinding('class.ngx-excel-cell--head') excelCellClass = true;
  @HostBinding('class.ngx-excel-cell--head-upload') excelCellUploadClass = false;
  @HostBinding('class.ngx-excel-cell--head-multiline-text') excelCellMultilineTextClass = false;

  ngOnInit() {
    if (this.column.columnType === NgxExcelColumnType.UploadFile || this.column.columnType === NgxExcelColumnType.MultiUploadFile) {
      this._initialUploadCell();
    } else if (this.column.columnType === NgxExcelColumnType.MultilineText) {
      this._initialMultilineTextCell();
    }
  }

  ngAfterContentInit() {
    if (!this.excelContext) { return; }
    this.excelContext.initialCellComponent(this);
  }

  private _initialUploadCell() {
    this.excelCellUploadClass = true;
  }

  private _initialMultilineTextCell() {
    this.excelCellMultilineTextClass = true;
  }

}
